export default {
  gap: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem'
  }
}
